/**
 * chat-trigger.js
 *
 * Opens the Gorgias chat widget from any "Start Chat" style trigger without
 * requiring per-page JS. Delegated on the document so it works for links added
 * through the theme editor (rich text, buttons, etc.).
 *
 * Wire a trigger by either:
 *   - <a href="#start-chat">Start Chat</a>
 *   - any element with a data-start-chat attribute
 *
 * The Gorgias chat SDK is injected globally by the Gorgias app, so window
 * .GorgiasChat may not exist yet on first paint; we fall back to clicking the
 * launcher, then briefly poll for the SDK.
 */

const TRIGGER_SELECTOR = 'a[href$="#start-chat"], [data-start-chat]';
const LAUNCHER_SELECTOR = '#gorgias-chat-container button, [id^="gorgias-chat"] button, #chat-button';

function openChat() {
  const chat = /** @type {any} */ (window).GorgiasChat;
  if (chat && typeof chat.open === 'function') {
    chat.open();
    return true;
  }
  const launcher = /** @type {HTMLElement|null} */ (document.querySelector(LAUNCHER_SELECTOR));
  if (launcher) {
    launcher.click();
    return true;
  }
  return false;
}

function openChatWithRetry() {
  if (openChat()) return;
  // SDK/launcher not ready yet — poll briefly.
  const start = Date.now();
  const interval = setInterval(() => {
    if (openChat() || Date.now() - start > 8000) clearInterval(interval);
  }, 150);
}

document.addEventListener('click', (event) => {
  const target = /** @type {HTMLElement | null} */ (event.target);
  const trigger = target?.closest?.(TRIGGER_SELECTOR);
  if (!trigger) return;
  event.preventDefault();
  openChatWithRetry();
});
